<template>
  <div :style="{height: height + 'px'}" class="nodata f-df f-ai f-jc">
    <figure class="ndpic">
      <img :src="imgSrc" width="100%">
    </figure>
    <p v-if="!isHasSolt" class="f-tac nodatatxt">{{ warntxts }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    warntxts: {
      type: String,
      default: '暂无数据'
    },
    height: {
      type: String,
      default: '500'
    },
    isHasSolt: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgSrc: require('@/assets/images/nodata.png')
    }
  }
}
</script>

<style scoped>
.no-data-show{
  min-height: 300px;
}
.ndpic{
  width: 40px;
  padding: 15px 0;
  & img{margin-top: 5px;}
}
.nodatatxt{
  font-size: 14px;
  color: #333;
  margin-left: 5px;
}
</style>
